/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  HomeContentDynamicZoneInput: { input: any; output: any; }
  /** A string used to identify an i18n locale */
  I18NLocaleCode: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any; }
  StandardLpContentDynamicZoneInput: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Article = {
  __typename?: 'Article';
  articleContent?: Maybe<Scalars['String']['output']>;
  articleFaq?: Maybe<Array<Maybe<ComponentSimpleComponentsFaq>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ArticleRelationResponseCollection>;
  mentors?: Maybe<MentorRelationResponseCollection>;
  minuteRead?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<MentorRelationResponseCollection>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ArticleArticleFaqArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleLocalizationsArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleMentorsArgs = {
  filters?: InputMaybe<MentorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleReviewedByArgs = {
  filters?: InputMaybe<MentorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleEntity = {
  __typename?: 'ArticleEntity';
  attributes?: Maybe<Article>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ArticleEntityResponse = {
  __typename?: 'ArticleEntityResponse';
  data?: Maybe<ArticleEntity>;
};

export type ArticleEntityResponseCollection = {
  __typename?: 'ArticleEntityResponseCollection';
  data: Array<ArticleEntity>;
  meta: ResponseCollectionMeta;
};

export type ArticleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  articleContent?: InputMaybe<StringFilterInput>;
  articleFaq?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ArticleFiltersInput>;
  mentors?: InputMaybe<MentorFiltersInput>;
  minuteRead?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reviewedBy?: InputMaybe<MentorFiltersInput>;
  shortDescription?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ArticleInput = {
  articleContent?: InputMaybe<Scalars['String']['input']>;
  articleFaq?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsFaqInput>>>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  minuteRead?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reviewedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleRelationResponseCollection = {
  __typename?: 'ArticleRelationResponseCollection';
  data: Array<ArticleEntity>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommunityDetail = {
  __typename?: 'CommunityDetail';
  CommunityDetail?: Maybe<ComponentHomeCommunityImages>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommunityDetailEntity = {
  __typename?: 'CommunityDetailEntity';
  attributes?: Maybe<CommunityDetail>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CommunityDetailEntityResponse = {
  __typename?: 'CommunityDetailEntityResponse';
  data?: Maybe<CommunityDetailEntity>;
};

export type CommunityDetailEntityResponseCollection = {
  __typename?: 'CommunityDetailEntityResponseCollection';
  data: Array<CommunityDetailEntity>;
  meta: ResponseCollectionMeta;
};

export type CommunityDetailFiltersInput = {
  CommunityDetail?: InputMaybe<ComponentHomeCommunityImagesFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<CommunityDetailFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CommunityDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CommunityDetailFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CommunityDetailInput = {
  CommunityDetail?: InputMaybe<ComponentHomeCommunityImagesInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommunityDetailRelationResponseCollection = {
  __typename?: 'CommunityDetailRelationResponseCollection';
  data: Array<CommunityDetailEntity>;
};

export type ComponentComplexComponentsImageCard = {
  __typename?: 'ComponentComplexComponentsImageCard';
  BigText?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<UploadFileEntityResponse>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentComplexComponentsImageCardFiltersInput = {
  BigText?: InputMaybe<StringFilterInput>;
  SmallText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsImageCardFiltersInput>>>;
  not?: InputMaybe<ComponentComplexComponentsImageCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsImageCardFiltersInput>>>;
};

export type ComponentComplexComponentsImages = {
  __typename?: 'ComponentComplexComponentsImages';
  CompanyImage?: Maybe<UploadFileEntityResponse>;
  StudentImage?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
};

export type ComponentComplexComponentsImagesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsImagesFiltersInput>>>;
  not?: InputMaybe<ComponentComplexComponentsImagesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsImagesFiltersInput>>>;
};

export type ComponentComplexComponentsSectionalFaq = {
  __typename?: 'ComponentComplexComponentsSectionalFaq';
  CaptionText?: Maybe<Scalars['String']['output']>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  faq?: Maybe<Array<Maybe<ComponentSimpleComponentsFaq>>>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentComplexComponentsSectionalFaqFaqArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentComplexComponentsSectionalFaqFiltersInput = {
  CaptionText?: InputMaybe<StringFilterInput>;
  Hide?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>>>;
  faq?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  not?: InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentComplexComponentsSectionalFaqInput = {
  CaptionText?: InputMaybe<Scalars['String']['input']>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  faq?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsFaqInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentComplexComponentsSubTopic = {
  __typename?: 'ComponentComplexComponentsSubTopic';
  articles?: Maybe<ArticleRelationResponseCollection>;
  id: Scalars['ID']['output'];
  subTopicDescription?: Maybe<Scalars['String']['output']>;
  subTopicName?: Maybe<Scalars['String']['output']>;
  subTopicfaq?: Maybe<Array<Maybe<ComponentSimpleComponentsFaq>>>;
};


export type ComponentComplexComponentsSubTopicArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentComplexComponentsSubTopicSubTopicfaqArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentComplexComponentsSubTopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSubTopicFiltersInput>>>;
  articles?: InputMaybe<ArticleFiltersInput>;
  not?: InputMaybe<ComponentComplexComponentsSubTopicFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSubTopicFiltersInput>>>;
  subTopicDescription?: InputMaybe<StringFilterInput>;
  subTopicName?: InputMaybe<StringFilterInput>;
  subTopicfaq?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
};

export type ComponentComplexComponentsSubTopicInput = {
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subTopicDescription?: InputMaybe<Scalars['String']['input']>;
  subTopicName?: InputMaybe<Scalars['String']['input']>;
  subTopicfaq?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsFaqInput>>>;
};

export type ComponentComplexComponentsSuccessCard = {
  __typename?: 'ComponentComplexComponentsSuccessCard';
  FromCompany?: Maybe<Scalars['String']['output']>;
  FromText?: Maybe<Scalars['String']['output']>;
  StudentImage?: Maybe<UploadFileEntityResponse>;
  StudentName?: Maybe<Scalars['String']['output']>;
  ToCompany?: Maybe<Scalars['String']['output']>;
  ToText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentComplexComponentsSuccessCardFiltersInput = {
  FromCompany?: InputMaybe<StringFilterInput>;
  FromText?: InputMaybe<StringFilterInput>;
  StudentName?: InputMaybe<StringFilterInput>;
  ToCompany?: InputMaybe<StringFilterInput>;
  ToText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSuccessCardFiltersInput>>>;
  not?: InputMaybe<ComponentComplexComponentsSuccessCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSuccessCardFiltersInput>>>;
};

export type ComponentHomeAdvantage = {
  __typename?: 'ComponentHomeAdvantage';
  BigText?: Maybe<Scalars['String']['output']>;
  Slider?: Maybe<Array<Maybe<ComponentComplexComponentsImageCard>>>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeAdvantageSliderArgs = {
  filters?: InputMaybe<ComponentComplexComponentsImageCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeBehindOurGrowth = {
  __typename?: 'ComponentHomeBehindOurGrowth';
  BigText?: Maybe<Scalars['String']['output']>;
  CompanyLogos?: Maybe<UploadFileRelationResponseCollection>;
  GrowthTeamImages?: Maybe<Array<Maybe<ComponentSimpleComponentsGrowthTeamImages>>>;
  SmallText?: Maybe<Scalars['String']['output']>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeBehindOurGrowthCompanyLogosArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentHomeBehindOurGrowthGrowthTeamImagesArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsGrowthTeamImagesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeCommunityImages = {
  __typename?: 'ComponentHomeCommunityImages';
  Caption?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<UploadFileEntityResponse>;
  Location?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentHomeCommunityImagesFiltersInput = {
  Caption?: InputMaybe<StringFilterInput>;
  Location?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentHomeCommunityImagesFiltersInput>>>;
  not?: InputMaybe<ComponentHomeCommunityImagesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeCommunityImagesFiltersInput>>>;
};

export type ComponentHomeCommunityImagesInput = {
  Caption?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  Location?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentHomeCrads = {
  __typename?: 'ComponentHomeCrads';
  Description?: Maybe<Scalars['String']['output']>;
  Designation?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<UploadFileEntityResponse>;
  Name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentHomeCradsFiltersInput = {
  Description?: InputMaybe<StringFilterInput>;
  Designation?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentHomeCradsFiltersInput>>>;
  not?: InputMaybe<ComponentHomeCradsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeCradsFiltersInput>>>;
};

export type ComponentHomeFeedBackCards = {
  __typename?: 'ComponentHomeFeedBackCards';
  Description?: Maybe<Scalars['String']['output']>;
  Designation?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<UploadFileEntityResponse>;
  IsTextTestimonial?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  SocialIcon?: Maybe<UploadFileEntityResponse>;
  SocialLink?: Maybe<Scalars['String']['output']>;
  Video?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
};

export type ComponentHomeFeedBackCardsFiltersInput = {
  Description?: InputMaybe<StringFilterInput>;
  Designation?: InputMaybe<StringFilterInput>;
  IsTextTestimonial?: InputMaybe<BooleanFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  SocialLink?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentHomeFeedBackCardsFiltersInput>>>;
  not?: InputMaybe<ComponentHomeFeedBackCardsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeFeedBackCardsFiltersInput>>>;
};

export type ComponentHomeFeedBackDetail = {
  __typename?: 'ComponentHomeFeedBackDetail';
  BigText?: Maybe<Scalars['String']['output']>;
  FeedBackCards?: Maybe<Array<Maybe<ComponentHomeFeedBackCards>>>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeFeedBackDetailFeedBackCardsArgs = {
  filters?: InputMaybe<ComponentHomeFeedBackCardsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeFirstBlock = {
  __typename?: 'ComponentHomeFirstBlock';
  CTA?: Maybe<ComponentSimpleComponentsButton>;
  Description?: Maybe<Scalars['String']['output']>;
  TextScroll?: Maybe<Array<Maybe<ComponentSimpleComponentsTextScroll>>>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeFirstBlockTextScrollArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsTextScrollFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeGlimpse = {
  __typename?: 'ComponentHomeGlimpse';
  QuizLink?: Maybe<ComponentSimpleComponentsButton>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentHomeOurCommunity = {
  __typename?: 'ComponentHomeOurCommunity';
  ButtonLink?: Maybe<Scalars['String']['output']>;
  ButtonText?: Maybe<Scalars['String']['output']>;
  Caption?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ComponentSimpleComponentsCategories>>>;
  Description?: Maybe<Scalars['String']['output']>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeOurCommunityCategoriesArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsCategoriesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeOurCommunityInput = {
  ButtonLink?: InputMaybe<Scalars['String']['input']>;
  ButtonText?: InputMaybe<Scalars['String']['input']>;
  Caption?: InputMaybe<Scalars['String']['input']>;
  Categories?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsCategoriesInput>>>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentHomeRecommendedCard = {
  __typename?: 'ComponentHomeRecommendedCard';
  BigText?: Maybe<Scalars['String']['output']>;
  Crads?: Maybe<Array<Maybe<ComponentHomeCrads>>>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeRecommendedCardCradsArgs = {
  filters?: InputMaybe<ComponentHomeCradsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeSecondBlock = {
  __typename?: 'ComponentHomeSecondBlock';
  StudentCount?: Maybe<Scalars['Long']['output']>;
  StudentDescription?: Maybe<Scalars['String']['output']>;
  StudentText?: Maybe<Scalars['String']['output']>;
  Students?: Maybe<Array<Maybe<ComponentComplexComponentsImages>>>;
  TrustCards?: Maybe<Array<Maybe<ComponentComplexComponentsImageCard>>>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeSecondBlockStudentsArgs = {
  filters?: InputMaybe<ComponentComplexComponentsImagesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentHomeSecondBlockTrustCardsArgs = {
  filters?: InputMaybe<ComponentComplexComponentsImageCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeSkillUpDetail = {
  __typename?: 'ComponentHomeSkillUpDetail';
  BrandCollabTitle?: Maybe<Scalars['String']['output']>;
  ButtonLink?: Maybe<Scalars['String']['output']>;
  ButtonText?: Maybe<Scalars['String']['output']>;
  Caption?: Maybe<Scalars['String']['output']>;
  CollaborationBrand?: Maybe<Array<Maybe<ComponentSimpleComponentsBrandLogos>>>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  WhyUs?: Maybe<Array<Maybe<ComponentHomeWhyUs>>>;
  WhyUsTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeSkillUpDetailCollaborationBrandArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsBrandLogosFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentHomeSkillUpDetailWhyUsArgs = {
  filters?: InputMaybe<ComponentHomeWhyUsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeSuccessStories = {
  __typename?: 'ComponentHomeSuccessStories';
  BigText?: Maybe<Scalars['String']['output']>;
  SmallText?: Maybe<Scalars['String']['output']>;
  SuccessCard?: Maybe<Array<Maybe<ComponentComplexComponentsSuccessCard>>>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeSuccessStoriesSuccessCardArgs = {
  filters?: InputMaybe<ComponentComplexComponentsSuccessCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeTopBrands = {
  __typename?: 'ComponentHomeTopBrands';
  BrandLogos?: Maybe<Array<Maybe<ComponentSimpleComponentsBrandLogos>>>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeTopBrandsBrandLogosArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsBrandLogosFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeWhyUs = {
  __typename?: 'ComponentHomeWhyUs';
  Description?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<UploadFileEntityResponse>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentHomeWhyUsFiltersInput = {
  Description?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentHomeWhyUsFiltersInput>>>;
  not?: InputMaybe<ComponentHomeWhyUsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeWhyUsFiltersInput>>>;
};

export type ComponentMembershipPageBenefitsDetail = {
  __typename?: 'ComponentMembershipPageBenefitsDetail';
  Detail?: Maybe<Scalars['String']['output']>;
  Price?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentMembershipPageBenefitsDetailFiltersInput = {
  Detail?: InputMaybe<StringFilterInput>;
  Price?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMembershipPageBenefitsDetailFiltersInput>>>;
  not?: InputMaybe<ComponentMembershipPageBenefitsDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMembershipPageBenefitsDetailFiltersInput>>>;
};

export type ComponentMembershipPageBenefitsDetailInput = {
  Detail?: InputMaybe<Scalars['String']['input']>;
  Price?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageCommunitySpace = {
  __typename?: 'ComponentMembershipPageCommunitySpace';
  CaptionText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  Image?: Maybe<UploadFileEntityResponse>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentMembershipPageCommunitySpaceInput = {
  CaptionText?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageContentDetail = {
  __typename?: 'ComponentMembershipPageContentDetail';
  IsAllAccess?: Maybe<Scalars['Boolean']['output']>;
  IsGsPro?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentMembershipPageContentDetailFiltersInput = {
  IsAllAccess?: InputMaybe<BooleanFilterInput>;
  IsGsPro?: InputMaybe<BooleanFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMembershipPageContentDetailFiltersInput>>>;
  not?: InputMaybe<ComponentMembershipPageContentDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMembershipPageContentDetailFiltersInput>>>;
};

export type ComponentMembershipPageContentDetailInput = {
  IsAllAccess?: InputMaybe<Scalars['Boolean']['input']>;
  IsGsPro?: InputMaybe<Scalars['Boolean']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageCoursesCards = {
  __typename?: 'ComponentMembershipPageCoursesCards';
  Details?: Maybe<Array<Maybe<ComponentMembershipPageDetails>>>;
  Price?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  WorthText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentMembershipPageCoursesCardsDetailsArgs = {
  filters?: InputMaybe<ComponentMembershipPageDetailsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMembershipPageCoursesCardsFiltersInput = {
  Details?: InputMaybe<ComponentMembershipPageDetailsFiltersInput>;
  Price?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  WorthText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMembershipPageCoursesCardsFiltersInput>>>;
  not?: InputMaybe<ComponentMembershipPageCoursesCardsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMembershipPageCoursesCardsFiltersInput>>>;
};

export type ComponentMembershipPageCoursesCardsInput = {
  Details?: InputMaybe<Array<InputMaybe<ComponentMembershipPageDetailsInput>>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  WorthText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageCoursesDetail = {
  __typename?: 'ComponentMembershipPageCoursesDetail';
  CaptionText?: Maybe<Scalars['String']['output']>;
  CoursesCards?: Maybe<Array<Maybe<ComponentMembershipPageCoursesCards>>>;
  Description?: Maybe<Scalars['String']['output']>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentMembershipPageCoursesDetailCoursesCardsArgs = {
  filters?: InputMaybe<ComponentMembershipPageCoursesCardsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMembershipPageCoursesDetailInput = {
  CaptionText?: InputMaybe<Scalars['String']['input']>;
  CoursesCards?: InputMaybe<Array<InputMaybe<ComponentMembershipPageCoursesCardsInput>>>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageDescription = {
  __typename?: 'ComponentMembershipPageDescription';
  Detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentMembershipPageDetails = {
  __typename?: 'ComponentMembershipPageDetails';
  Detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentMembershipPageDetailsFiltersInput = {
  Detail?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMembershipPageDetailsFiltersInput>>>;
  not?: InputMaybe<ComponentMembershipPageDetailsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMembershipPageDetailsFiltersInput>>>;
};

export type ComponentMembershipPageDetailsInput = {
  Detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageDoubtSection = {
  __typename?: 'ComponentMembershipPageDoubtSection';
  CaptionText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DoubtTopics?: Maybe<Array<Maybe<ComponentMembershipPageDoubtTopics>>>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentMembershipPageDoubtSectionDoubtTopicsArgs = {
  filters?: InputMaybe<ComponentMembershipPageDoubtTopicsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMembershipPageDoubtSectionInput = {
  CaptionText?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DoubtTopics?: InputMaybe<Array<InputMaybe<ComponentMembershipPageDoubtTopicsInput>>>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageDoubtTopics = {
  __typename?: 'ComponentMembershipPageDoubtTopics';
  Description?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<UploadFileEntityResponse>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentMembershipPageDoubtTopicsFiltersInput = {
  Description?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMembershipPageDoubtTopicsFiltersInput>>>;
  not?: InputMaybe<ComponentMembershipPageDoubtTopicsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMembershipPageDoubtTopicsFiltersInput>>>;
};

export type ComponentMembershipPageDoubtTopicsInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Icon?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageHeroSection = {
  __typename?: 'ComponentMembershipPageHeroSection';
  ButtonLink?: Maybe<Scalars['String']['output']>;
  ButtonText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  Price?: Maybe<Scalars['String']['output']>;
  SmallText?: Maybe<Scalars['String']['output']>;
  Thumbnail?: Maybe<UploadFileEntityResponse>;
  Title?: Maybe<Scalars['String']['output']>;
  Video?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
};

export type ComponentMembershipPageHeroSectionInput = {
  ButtonLink?: InputMaybe<Scalars['String']['input']>;
  ButtonText?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  Price?: InputMaybe<Scalars['String']['input']>;
  SmallText?: InputMaybe<Scalars['String']['input']>;
  Thumbnail?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Video?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPageJobBoard = {
  __typename?: 'ComponentMembershipPageJobBoard';
  CaptionText?: Maybe<Scalars['String']['output']>;
  ComingSoon?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  Image?: Maybe<UploadFileEntityResponse>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentMembershipPageJobBoardInput = {
  CaptionText?: InputMaybe<Scalars['String']['input']>;
  ComingSoon?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPagePlanBenefits = {
  __typename?: 'ComponentMembershipPagePlanBenefits';
  BenefitsDetail?: Maybe<Array<Maybe<ComponentMembershipPageBenefitsDetail>>>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  OfferPrice?: Maybe<Scalars['String']['output']>;
  OfferText?: Maybe<Scalars['String']['output']>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TotalPrice?: Maybe<Scalars['String']['output']>;
  TotalText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentMembershipPagePlanBenefitsBenefitsDetailArgs = {
  filters?: InputMaybe<ComponentMembershipPageBenefitsDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMembershipPagePlanBenefitsFiltersInput = {
  BenefitsDetail?: InputMaybe<ComponentMembershipPageBenefitsDetailFiltersInput>;
  Hide?: InputMaybe<BooleanFilterInput>;
  OfferPrice?: InputMaybe<StringFilterInput>;
  OfferText?: InputMaybe<StringFilterInput>;
  SubTitle?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  TotalPrice?: InputMaybe<StringFilterInput>;
  TotalText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMembershipPagePlanBenefitsFiltersInput>>>;
  not?: InputMaybe<ComponentMembershipPagePlanBenefitsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMembershipPagePlanBenefitsFiltersInput>>>;
};

export type ComponentMembershipPagePlanBenefitsInput = {
  BenefitsDetail?: InputMaybe<Array<InputMaybe<ComponentMembershipPageBenefitsDetailInput>>>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  OfferPrice?: InputMaybe<Scalars['String']['input']>;
  OfferText?: InputMaybe<Scalars['String']['input']>;
  SubTitle?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  TotalPrice?: InputMaybe<Scalars['String']['input']>;
  TotalText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPagePlanCategory = {
  __typename?: 'ComponentMembershipPagePlanCategory';
  PlanName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  plan_detail?: Maybe<PlanDetailEntityResponse>;
};

export type ComponentMembershipPagePlanCategoryFiltersInput = {
  PlanName?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMembershipPagePlanCategoryFiltersInput>>>;
  not?: InputMaybe<ComponentMembershipPagePlanCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMembershipPagePlanCategoryFiltersInput>>>;
  plan_detail?: InputMaybe<PlanDetailFiltersInput>;
};

export type ComponentMembershipPagePlanCategoryInput = {
  PlanName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  plan_detail?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPagePlanContent = {
  __typename?: 'ComponentMembershipPagePlanContent';
  AllAccess?: Maybe<Scalars['String']['output']>;
  AllAccessCourses?: Maybe<Scalars['String']['output']>;
  AllAccessPrice?: Maybe<Scalars['String']['output']>;
  ContentDetail?: Maybe<Array<Maybe<ComponentMembershipPageContentDetail>>>;
  Hide?: Maybe<Scalars['Boolean']['output']>;
  ProCourses?: Maybe<Scalars['String']['output']>;
  ProMembership?: Maybe<Scalars['String']['output']>;
  ProPlanPrice?: Maybe<Scalars['String']['output']>;
  SelfPlacedCourse?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentMembershipPagePlanContentContentDetailArgs = {
  filters?: InputMaybe<ComponentMembershipPageContentDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMembershipPagePlanContentFiltersInput = {
  AllAccess?: InputMaybe<StringFilterInput>;
  AllAccessCourses?: InputMaybe<StringFilterInput>;
  AllAccessPrice?: InputMaybe<StringFilterInput>;
  ContentDetail?: InputMaybe<ComponentMembershipPageContentDetailFiltersInput>;
  Hide?: InputMaybe<BooleanFilterInput>;
  ProCourses?: InputMaybe<StringFilterInput>;
  ProMembership?: InputMaybe<StringFilterInput>;
  ProPlanPrice?: InputMaybe<StringFilterInput>;
  SelfPlacedCourse?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMembershipPagePlanContentFiltersInput>>>;
  not?: InputMaybe<ComponentMembershipPagePlanContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMembershipPagePlanContentFiltersInput>>>;
};

export type ComponentMembershipPagePlanContentInput = {
  AllAccess?: InputMaybe<Scalars['String']['input']>;
  AllAccessCourses?: InputMaybe<Scalars['String']['input']>;
  AllAccessPrice?: InputMaybe<Scalars['String']['input']>;
  ContentDetail?: InputMaybe<Array<InputMaybe<ComponentMembershipPageContentDetailInput>>>;
  Hide?: InputMaybe<Scalars['Boolean']['input']>;
  ProCourses?: InputMaybe<Scalars['String']['input']>;
  ProMembership?: InputMaybe<Scalars['String']['input']>;
  ProPlanPrice?: InputMaybe<Scalars['String']['input']>;
  SelfPlacedCourse?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMembershipPagePlanDetail = {
  __typename?: 'ComponentMembershipPagePlanDetail';
  PlanCategory?: Maybe<Array<Maybe<ComponentMembershipPagePlanCategory>>>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentMembershipPagePlanDetailPlanCategoryArgs = {
  filters?: InputMaybe<ComponentMembershipPagePlanCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMembershipPagePlanDetailInput = {
  PlanCategory?: InputMaybe<Array<InputMaybe<ComponentMembershipPagePlanCategoryInput>>>;
  SubTitle?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSimpleComponentsAudienceDetail = {
  __typename?: 'ComponentSimpleComponentsAudienceDetail';
  Title?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
};

export type ComponentSimpleComponentsAudienceDetailFiltersInput = {
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsAudienceDetailFiltersInput>>>;
  not?: InputMaybe<ComponentSimpleComponentsAudienceDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsAudienceDetailFiltersInput>>>;
};

export type ComponentSimpleComponentsBrandLogos = {
  __typename?: 'ComponentSimpleComponentsBrandLogos';
  Image?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
};

export type ComponentSimpleComponentsBrandLogosFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsBrandLogosFiltersInput>>>;
  not?: InputMaybe<ComponentSimpleComponentsBrandLogosFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsBrandLogosFiltersInput>>>;
};

export type ComponentSimpleComponentsButton = {
  __typename?: 'ComponentSimpleComponentsButton';
  Link?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSimpleComponentsCategories = {
  __typename?: 'ComponentSimpleComponentsCategories';
  BigText?: Maybe<Scalars['String']['output']>;
  CategoryName?: Maybe<Scalars['String']['output']>;
  SmallText?: Maybe<Scalars['String']['output']>;
  community_details?: Maybe<CommunityDetailRelationResponseCollection>;
  id: Scalars['ID']['output'];
};


export type ComponentSimpleComponentsCategoriesCommunity_DetailsArgs = {
  filters?: InputMaybe<CommunityDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSimpleComponentsCategoriesFiltersInput = {
  BigText?: InputMaybe<StringFilterInput>;
  CategoryName?: InputMaybe<StringFilterInput>;
  SmallText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsCategoriesFiltersInput>>>;
  community_details?: InputMaybe<CommunityDetailFiltersInput>;
  not?: InputMaybe<ComponentSimpleComponentsCategoriesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsCategoriesFiltersInput>>>;
};

export type ComponentSimpleComponentsCategoriesInput = {
  BigText?: InputMaybe<Scalars['String']['input']>;
  CategoryName?: InputMaybe<Scalars['String']['input']>;
  SmallText?: InputMaybe<Scalars['String']['input']>;
  community_details?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSimpleComponentsCompanyImage = {
  __typename?: 'ComponentSimpleComponentsCompanyImage';
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSimpleComponentsCourseContent = {
  __typename?: 'ComponentSimpleComponentsCourseContent';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentSimpleComponentsCourseContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsCourseContentFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSimpleComponentsCourseContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsCourseContentFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSimpleComponentsCourseContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSimpleComponentsFaq = {
  __typename?: 'ComponentSimpleComponentsFaq';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentSimpleComponentsFaqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsFaqFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsFaqFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentSimpleComponentsFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSimpleComponentsGrowthTeamImages = {
  __typename?: 'ComponentSimpleComponentsGrowthTeamImages';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentSimpleComponentsGrowthTeamImagesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsGrowthTeamImagesFiltersInput>>>;
  not?: InputMaybe<ComponentSimpleComponentsGrowthTeamImagesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsGrowthTeamImagesFiltersInput>>>;
};

export type ComponentSimpleComponentsLearnerInfo = {
  __typename?: 'ComponentSimpleComponentsLearnerInfo';
  Description?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
};

export type ComponentSimpleComponentsLearnerInfoFiltersInput = {
  Description?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsLearnerInfoFiltersInput>>>;
  not?: InputMaybe<ComponentSimpleComponentsLearnerInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsLearnerInfoFiltersInput>>>;
};

export type ComponentSimpleComponentsOutcomes = {
  __typename?: 'ComponentSimpleComponentsOutcomes';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentSimpleComponentsOutcomesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsOutcomesFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSimpleComponentsOutcomesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsOutcomesFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSimpleComponentsOutcomesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSimpleComponentsStudentCompanyImages = {
  __typename?: 'ComponentSimpleComponentsStudentCompanyImages';
  CompanyImage?: Maybe<UploadFileRelationResponseCollection>;
  StudentImage?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
};


export type ComponentSimpleComponentsStudentCompanyImagesCompanyImageArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSimpleComponentsTextScroll = {
  __typename?: 'ComponentSimpleComponentsTextScroll';
  Text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSimpleComponentsTextScrollFiltersInput = {
  Text?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsTextScrollFiltersInput>>>;
  not?: InputMaybe<ComponentSimpleComponentsTextScrollFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsTextScrollFiltersInput>>>;
};

export type ComponentSimpleComponentsWhoIsItFor = {
  __typename?: 'ComponentSimpleComponentsWhoIsItFor';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentSimpleComponentsWhoIsItForFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsWhoIsItForFiltersInput>>>;
  not?: InputMaybe<ComponentSimpleComponentsWhoIsItForFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsWhoIsItForFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSimpleComponentsWhoIsItForInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentStndardLpCertificate = {
  __typename?: 'ComponentStndardLpCertificate';
  Image?: Maybe<UploadFileEntityResponse>;
  SectionInfo?: Maybe<ComponentStndardLpModuleDetail>;
  id: Scalars['ID']['output'];
};

export type ComponentStndardLpFaqDetail = {
  __typename?: 'ComponentStndardLpFaqDetail';
  BigText?: Maybe<Scalars['String']['output']>;
  FaqDetail?: Maybe<Array<Maybe<ComponentSimpleComponentsFaq>>>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentStndardLpFaqDetailFaqDetailArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentStndardLpKeyOutComes = {
  __typename?: 'ComponentStndardLpKeyOutComes';
  BigText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentStndardLpLearnerDetail = {
  __typename?: 'ComponentStndardLpLearnerDetail';
  BigText?: Maybe<Scalars['String']['output']>;
  CompanyLogo?: Maybe<UploadFileEntityResponse>;
  LearnerInfo?: Maybe<Array<Maybe<ComponentSimpleComponentsLearnerInfo>>>;
  SmallText?: Maybe<Scalars['String']['output']>;
  SocialIcon?: Maybe<UploadFileEntityResponse>;
  StudentCount?: Maybe<Scalars['Long']['output']>;
  StudentDescription?: Maybe<Scalars['String']['output']>;
  StudentText?: Maybe<Scalars['String']['output']>;
  Students?: Maybe<Array<Maybe<ComponentComplexComponentsImages>>>;
  id: Scalars['ID']['output'];
};


export type ComponentStndardLpLearnerDetailLearnerInfoArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsLearnerInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentStndardLpLearnerDetailStudentsArgs = {
  filters?: InputMaybe<ComponentComplexComponentsImagesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentStndardLpModuleDetail = {
  __typename?: 'ComponentStndardLpModuleDetail';
  BigText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentStndardLpModuleDetailFiltersInput = {
  BigText?: InputMaybe<StringFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  SmallText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentStndardLpModuleDetailFiltersInput>>>;
  not?: InputMaybe<ComponentStndardLpModuleDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentStndardLpModuleDetailFiltersInput>>>;
};

export type ComponentStndardLpTargetAudience = {
  __typename?: 'ComponentStndardLpTargetAudience';
  AudienceDetail?: Maybe<Array<Maybe<ComponentSimpleComponentsAudienceDetail>>>;
  BigText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentStndardLpTargetAudienceAudienceDetailArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsAudienceDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentStndardLpWhatYouLearn = {
  __typename?: 'ComponentStndardLpWhatYouLearn';
  BigText?: Maybe<Scalars['String']['output']>;
  ModuleDetail?: Maybe<Array<Maybe<ComponentStndardLpModuleDetail>>>;
  SmallText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentStndardLpWhatYouLearnModuleDetailArgs = {
  filters?: InputMaybe<ComponentStndardLpModuleDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentReleasesRelease = {
  __typename?: 'ContentReleasesRelease';
  actions?: Maybe<ContentReleasesReleaseActionRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ContentReleasesReleaseActionsArgs = {
  filters?: InputMaybe<ContentReleasesReleaseActionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentReleasesReleaseAction = {
  __typename?: 'ContentReleasesReleaseAction';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entry?: Maybe<GenericMorph>;
  locale?: Maybe<Scalars['String']['output']>;
  release?: Maybe<ContentReleasesReleaseEntityResponse>;
  type: Enum_Contentreleasesreleaseaction_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentReleasesReleaseActionEntity = {
  __typename?: 'ContentReleasesReleaseActionEntity';
  attributes?: Maybe<ContentReleasesReleaseAction>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ContentReleasesReleaseActionEntityResponse = {
  __typename?: 'ContentReleasesReleaseActionEntityResponse';
  data?: Maybe<ContentReleasesReleaseActionEntity>;
};

export type ContentReleasesReleaseActionEntityResponseCollection = {
  __typename?: 'ContentReleasesReleaseActionEntityResponseCollection';
  data: Array<ContentReleasesReleaseActionEntity>;
  meta: ResponseCollectionMeta;
};

export type ContentReleasesReleaseActionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ContentReleasesReleaseActionFiltersInput>>>;
  contentType?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContentReleasesReleaseActionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ContentReleasesReleaseActionFiltersInput>>>;
  release?: InputMaybe<ContentReleasesReleaseFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ContentReleasesReleaseActionInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  release?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Contentreleasesreleaseaction_Type>;
};

export type ContentReleasesReleaseActionRelationResponseCollection = {
  __typename?: 'ContentReleasesReleaseActionRelationResponseCollection';
  data: Array<ContentReleasesReleaseActionEntity>;
};

export type ContentReleasesReleaseEntity = {
  __typename?: 'ContentReleasesReleaseEntity';
  attributes?: Maybe<ContentReleasesRelease>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ContentReleasesReleaseEntityResponse = {
  __typename?: 'ContentReleasesReleaseEntityResponse';
  data?: Maybe<ContentReleasesReleaseEntity>;
};

export type ContentReleasesReleaseEntityResponseCollection = {
  __typename?: 'ContentReleasesReleaseEntityResponseCollection';
  data: Array<ContentReleasesReleaseEntity>;
  meta: ResponseCollectionMeta;
};

export type ContentReleasesReleaseFiltersInput = {
  actions?: InputMaybe<ContentReleasesReleaseActionFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ContentReleasesReleaseFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContentReleasesReleaseFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ContentReleasesReleaseFiltersInput>>>;
  releasedAt?: InputMaybe<DateTimeFilterInput>;
  scheduledAt?: InputMaybe<DateTimeFilterInput>;
  timezone?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ContentReleasesReleaseInput = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  releasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Enum_Contentreleasesreleaseaction_Type {
  Publish = 'publish',
  Unpublish = 'unpublish'
}

export enum Enum_Freecourse_Coursedifficulty {
  Advanced = 'Advanced',
  Beginner = 'Beginner',
  Intermediate = 'Intermediate'
}

export enum Enum_Testimonial_Userprofiletype {
  Linkedin = 'Linkedin',
  Twitter = 'Twitter'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type FreeCourse = {
  __typename?: 'FreeCourse';
  certificateAvailable: Scalars['Boolean']['output'];
  certificateImage?: Maybe<UploadFileEntityResponse>;
  courseCurriculum?: Maybe<Array<Maybe<ComponentSimpleComponentsCourseContent>>>;
  courseCurriculumDescription?: Maybe<Scalars['String']['output']>;
  courseDescription?: Maybe<Scalars['String']['output']>;
  courseDifficulty: Enum_Freecourse_Coursedifficulty;
  courseName: Scalars['String']['output'];
  courseRating?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  faq?: Maybe<Array<Maybe<ComponentSimpleComponentsFaq>>>;
  industries?: Maybe<IndustryRelationResponseCollection>;
  isPremium?: Maybe<Scalars['Boolean']['output']>;
  mentors?: Maybe<MentorRelationResponseCollection>;
  outcomes?: Maybe<Array<Maybe<ComponentSimpleComponentsOutcomes>>>;
  premiumCardLink?: Maybe<Scalars['String']['output']>;
  premiumCourseDuration?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subIndustries?: Maybe<SubIndustryRelationResponseCollection>;
  thumbnailText: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  webinarId: Scalars['Int']['output'];
  whoIsItFor?: Maybe<Array<Maybe<ComponentSimpleComponentsWhoIsItFor>>>;
};


export type FreeCourseCourseCurriculumArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsCourseContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FreeCourseFaqArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FreeCourseIndustriesArgs = {
  filters?: InputMaybe<IndustryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FreeCourseMentorsArgs = {
  filters?: InputMaybe<MentorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FreeCourseOutcomesArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsOutcomesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FreeCourseSubIndustriesArgs = {
  filters?: InputMaybe<SubIndustryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FreeCourseWhoIsItForArgs = {
  filters?: InputMaybe<ComponentSimpleComponentsWhoIsItForFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FreeCourseEntity = {
  __typename?: 'FreeCourseEntity';
  attributes?: Maybe<FreeCourse>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FreeCourseEntityResponse = {
  __typename?: 'FreeCourseEntityResponse';
  data?: Maybe<FreeCourseEntity>;
};

export type FreeCourseEntityResponseCollection = {
  __typename?: 'FreeCourseEntityResponseCollection';
  data: Array<FreeCourseEntity>;
  meta: ResponseCollectionMeta;
};

export type FreeCourseFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FreeCourseFiltersInput>>>;
  certificateAvailable?: InputMaybe<BooleanFilterInput>;
  courseCurriculum?: InputMaybe<ComponentSimpleComponentsCourseContentFiltersInput>;
  courseCurriculumDescription?: InputMaybe<StringFilterInput>;
  courseDescription?: InputMaybe<StringFilterInput>;
  courseDifficulty?: InputMaybe<StringFilterInput>;
  courseName?: InputMaybe<StringFilterInput>;
  courseRating?: InputMaybe<FloatFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  faq?: InputMaybe<ComponentSimpleComponentsFaqFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  industries?: InputMaybe<IndustryFiltersInput>;
  isPremium?: InputMaybe<BooleanFilterInput>;
  mentors?: InputMaybe<MentorFiltersInput>;
  not?: InputMaybe<FreeCourseFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FreeCourseFiltersInput>>>;
  outcomes?: InputMaybe<ComponentSimpleComponentsOutcomesFiltersInput>;
  premiumCardLink?: InputMaybe<StringFilterInput>;
  premiumCourseDuration?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subIndustries?: InputMaybe<SubIndustryFiltersInput>;
  thumbnailText?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  webinarId?: InputMaybe<IntFilterInput>;
  whoIsItFor?: InputMaybe<ComponentSimpleComponentsWhoIsItForFiltersInput>;
};

export type FreeCourseInput = {
  certificateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  certificateImage?: InputMaybe<Scalars['ID']['input']>;
  courseCurriculum?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsCourseContentInput>>>;
  courseCurriculumDescription?: InputMaybe<Scalars['String']['input']>;
  courseDescription?: InputMaybe<Scalars['String']['input']>;
  courseDifficulty?: InputMaybe<Enum_Freecourse_Coursedifficulty>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  courseRating?: InputMaybe<Scalars['Float']['input']>;
  faq?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsFaqInput>>>;
  industries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  outcomes?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsOutcomesInput>>>;
  premiumCardLink?: InputMaybe<Scalars['String']['input']>;
  premiumCourseDuration?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subIndustries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  thumbnailText?: InputMaybe<Scalars['String']['input']>;
  webinarId?: InputMaybe<Scalars['Int']['input']>;
  whoIsItFor?: InputMaybe<Array<InputMaybe<ComponentSimpleComponentsWhoIsItForInput>>>;
};

export type FreeCourseRelationResponseCollection = {
  __typename?: 'FreeCourseRelationResponseCollection';
  data: Array<FreeCourseEntity>;
};

export type GenericMorph = Article | CommunityDetail | ComponentComplexComponentsImageCard | ComponentComplexComponentsImages | ComponentComplexComponentsSectionalFaq | ComponentComplexComponentsSubTopic | ComponentComplexComponentsSuccessCard | ComponentHomeAdvantage | ComponentHomeBehindOurGrowth | ComponentHomeCommunityImages | ComponentHomeCrads | ComponentHomeFeedBackCards | ComponentHomeFeedBackDetail | ComponentHomeFirstBlock | ComponentHomeGlimpse | ComponentHomeOurCommunity | ComponentHomeRecommendedCard | ComponentHomeSecondBlock | ComponentHomeSkillUpDetail | ComponentHomeSuccessStories | ComponentHomeTopBrands | ComponentHomeWhyUs | ComponentMembershipPageBenefitsDetail | ComponentMembershipPageCommunitySpace | ComponentMembershipPageContentDetail | ComponentMembershipPageCoursesCards | ComponentMembershipPageCoursesDetail | ComponentMembershipPageDescription | ComponentMembershipPageDetails | ComponentMembershipPageDoubtSection | ComponentMembershipPageDoubtTopics | ComponentMembershipPageHeroSection | ComponentMembershipPageJobBoard | ComponentMembershipPagePlanBenefits | ComponentMembershipPagePlanCategory | ComponentMembershipPagePlanContent | ComponentMembershipPagePlanDetail | ComponentSimpleComponentsAudienceDetail | ComponentSimpleComponentsBrandLogos | ComponentSimpleComponentsButton | ComponentSimpleComponentsCategories | ComponentSimpleComponentsCompanyImage | ComponentSimpleComponentsCourseContent | ComponentSimpleComponentsFaq | ComponentSimpleComponentsGrowthTeamImages | ComponentSimpleComponentsLearnerInfo | ComponentSimpleComponentsOutcomes | ComponentSimpleComponentsStudentCompanyImages | ComponentSimpleComponentsTextScroll | ComponentSimpleComponentsWhoIsItFor | ComponentStndardLpCertificate | ComponentStndardLpFaqDetail | ComponentStndardLpKeyOutComes | ComponentStndardLpLearnerDetail | ComponentStndardLpModuleDetail | ComponentStndardLpTargetAudience | ComponentStndardLpWhatYouLearn | ContentReleasesRelease | ContentReleasesReleaseAction | FreeCourse | Home | I18NLocale | Industry | MembershipPage | Mentor | PlanDetail | StandardLp | SubIndustry | Testimonial | Topic | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type Home = {
  __typename?: 'Home';
  content?: Maybe<Array<Maybe<HomeContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HomeContentDynamicZone = ComponentHomeAdvantage | ComponentHomeBehindOurGrowth | ComponentHomeFeedBackDetail | ComponentHomeFirstBlock | ComponentHomeGlimpse | ComponentHomeOurCommunity | ComponentHomeRecommendedCard | ComponentHomeSecondBlock | ComponentHomeSkillUpDetail | ComponentHomeSuccessStories | ComponentHomeTopBrands | Error;

export type HomeEntity = {
  __typename?: 'HomeEntity';
  attributes?: Maybe<Home>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HomeEntityResponse = {
  __typename?: 'HomeEntityResponse';
  data?: Maybe<HomeEntity>;
};

export type HomeInput = {
  content?: InputMaybe<Array<Scalars['HomeContentDynamicZoneInput']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type Industry = {
  __typename?: 'Industry';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  freeCourses?: Maybe<FreeCourseRelationResponseCollection>;
  industryName: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<IndustryRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionalFaq?: Maybe<Array<Maybe<ComponentComplexComponentsSectionalFaq>>>;
  subIndustries?: Maybe<SubIndustryRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type IndustryFreeCoursesArgs = {
  filters?: InputMaybe<FreeCourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type IndustryLocalizationsArgs = {
  filters?: InputMaybe<IndustryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type IndustrySectionalFaqArgs = {
  filters?: InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type IndustrySubIndustriesArgs = {
  filters?: InputMaybe<SubIndustryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IndustryEntity = {
  __typename?: 'IndustryEntity';
  attributes?: Maybe<Industry>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type IndustryEntityResponse = {
  __typename?: 'IndustryEntityResponse';
  data?: Maybe<IndustryEntity>;
};

export type IndustryEntityResponseCollection = {
  __typename?: 'IndustryEntityResponseCollection';
  data: Array<IndustryEntity>;
  meta: ResponseCollectionMeta;
};

export type IndustryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IndustryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  freeCourses?: InputMaybe<FreeCourseFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  industryName?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<IndustryFiltersInput>;
  not?: InputMaybe<IndustryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IndustryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sectionalFaq?: InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>;
  subIndustries?: InputMaybe<SubIndustryFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IndustryInput = {
  freeCourses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  industryName?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sectionalFaq?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSectionalFaqInput>>>;
  subIndustries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type IndustryRelationResponseCollection = {
  __typename?: 'IndustryRelationResponseCollection';
  data: Array<IndustryEntity>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type MembershipPage = {
  __typename?: 'MembershipPage';
  CommunitySpace?: Maybe<ComponentMembershipPageCommunitySpace>;
  CoursesDetail?: Maybe<ComponentMembershipPageCoursesDetail>;
  DoubtSection?: Maybe<ComponentMembershipPageDoubtSection>;
  FaqDetail?: Maybe<ComponentComplexComponentsSectionalFaq>;
  HeroSection?: Maybe<ComponentMembershipPageHeroSection>;
  JobBoard?: Maybe<ComponentMembershipPageJobBoard>;
  OurCommunity?: Maybe<ComponentHomeOurCommunity>;
  PlanDetail?: Maybe<ComponentMembershipPagePlanDetail>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MembershipPageEntity = {
  __typename?: 'MembershipPageEntity';
  attributes?: Maybe<MembershipPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MembershipPageEntityResponse = {
  __typename?: 'MembershipPageEntityResponse';
  data?: Maybe<MembershipPageEntity>;
};

export type MembershipPageInput = {
  CommunitySpace?: InputMaybe<ComponentMembershipPageCommunitySpaceInput>;
  CoursesDetail?: InputMaybe<ComponentMembershipPageCoursesDetailInput>;
  DoubtSection?: InputMaybe<ComponentMembershipPageDoubtSectionInput>;
  FaqDetail?: InputMaybe<ComponentComplexComponentsSectionalFaqInput>;
  HeroSection?: InputMaybe<ComponentMembershipPageHeroSectionInput>;
  JobBoard?: InputMaybe<ComponentMembershipPageJobBoardInput>;
  OurCommunity?: InputMaybe<ComponentHomeOurCommunityInput>;
  PlanDetail?: InputMaybe<ComponentMembershipPagePlanDetailInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mentor = {
  __typename?: 'Mentor';
  aboutMentor?: Maybe<Scalars['String']['output']>;
  articleReviewed?: Maybe<ArticleEntityResponse>;
  articleWritten?: Maybe<ArticleEntityResponse>;
  companyLogo?: Maybe<UploadFileEntityResponse>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  freeCourses?: Maybe<FreeCourseRelationResponseCollection>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<MentorRelationResponseCollection>;
  mentorImage?: Maybe<UploadFileEntityResponse>;
  mentorImageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  webinarMentorId?: Maybe<Scalars['Int']['output']>;
};


export type MentorFreeCoursesArgs = {
  filters?: InputMaybe<FreeCourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MentorLocalizationsArgs = {
  filters?: InputMaybe<MentorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MentorEntity = {
  __typename?: 'MentorEntity';
  attributes?: Maybe<Mentor>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MentorEntityResponse = {
  __typename?: 'MentorEntityResponse';
  data?: Maybe<MentorEntity>;
};

export type MentorEntityResponseCollection = {
  __typename?: 'MentorEntityResponseCollection';
  data: Array<MentorEntity>;
  meta: ResponseCollectionMeta;
};

export type MentorFiltersInput = {
  aboutMentor?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<MentorFiltersInput>>>;
  articleReviewed?: InputMaybe<ArticleFiltersInput>;
  articleWritten?: InputMaybe<ArticleFiltersInput>;
  companyName?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  designation?: InputMaybe<StringFilterInput>;
  freeCourses?: InputMaybe<FreeCourseFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<MentorFiltersInput>;
  mentorImageUrl?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MentorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MentorFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  webinarMentorId?: InputMaybe<IntFilterInput>;
};

export type MentorInput = {
  aboutMentor?: InputMaybe<Scalars['String']['input']>;
  articleReviewed?: InputMaybe<Scalars['ID']['input']>;
  articleWritten?: InputMaybe<Scalars['ID']['input']>;
  companyLogo?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  freeCourses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mentorImage?: InputMaybe<Scalars['ID']['input']>;
  mentorImageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  webinarMentorId?: InputMaybe<Scalars['Int']['input']>;
};

export type MentorRelationResponseCollection = {
  __typename?: 'MentorRelationResponseCollection';
  data: Array<MentorEntity>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createArticle?: Maybe<ArticleEntityResponse>;
  createArticleLocalization?: Maybe<ArticleEntityResponse>;
  createCommunityDetail?: Maybe<CommunityDetailEntityResponse>;
  createContentReleasesRelease?: Maybe<ContentReleasesReleaseEntityResponse>;
  createContentReleasesReleaseAction?: Maybe<ContentReleasesReleaseActionEntityResponse>;
  createFreeCourse?: Maybe<FreeCourseEntityResponse>;
  createIndustry?: Maybe<IndustryEntityResponse>;
  createIndustryLocalization?: Maybe<IndustryEntityResponse>;
  createMentor?: Maybe<MentorEntityResponse>;
  createMentorLocalization?: Maybe<MentorEntityResponse>;
  createPlanDetail?: Maybe<PlanDetailEntityResponse>;
  createStandardLp?: Maybe<StandardLpEntityResponse>;
  createSubIndustry?: Maybe<SubIndustryEntityResponse>;
  createSubIndustryLocalization?: Maybe<SubIndustryEntityResponse>;
  createTestimonial?: Maybe<TestimonialEntityResponse>;
  createTopic?: Maybe<TopicEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteArticle?: Maybe<ArticleEntityResponse>;
  deleteCommunityDetail?: Maybe<CommunityDetailEntityResponse>;
  deleteContentReleasesRelease?: Maybe<ContentReleasesReleaseEntityResponse>;
  deleteContentReleasesReleaseAction?: Maybe<ContentReleasesReleaseActionEntityResponse>;
  deleteFreeCourse?: Maybe<FreeCourseEntityResponse>;
  deleteHome?: Maybe<HomeEntityResponse>;
  deleteIndustry?: Maybe<IndustryEntityResponse>;
  deleteMembershipPage?: Maybe<MembershipPageEntityResponse>;
  deleteMentor?: Maybe<MentorEntityResponse>;
  deletePlanDetail?: Maybe<PlanDetailEntityResponse>;
  deleteStandardLp?: Maybe<StandardLpEntityResponse>;
  deleteSubIndustry?: Maybe<SubIndustryEntityResponse>;
  deleteTestimonial?: Maybe<TestimonialEntityResponse>;
  deleteTopic?: Maybe<TopicEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateArticle?: Maybe<ArticleEntityResponse>;
  updateCommunityDetail?: Maybe<CommunityDetailEntityResponse>;
  updateContentReleasesRelease?: Maybe<ContentReleasesReleaseEntityResponse>;
  updateContentReleasesReleaseAction?: Maybe<ContentReleasesReleaseActionEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateFreeCourse?: Maybe<FreeCourseEntityResponse>;
  updateHome?: Maybe<HomeEntityResponse>;
  updateIndustry?: Maybe<IndustryEntityResponse>;
  updateMembershipPage?: Maybe<MembershipPageEntityResponse>;
  updateMentor?: Maybe<MentorEntityResponse>;
  updatePlanDetail?: Maybe<PlanDetailEntityResponse>;
  updateStandardLp?: Maybe<StandardLpEntityResponse>;
  updateSubIndustry?: Maybe<SubIndustryEntityResponse>;
  updateTestimonial?: Maybe<TestimonialEntityResponse>;
  updateTopic?: Maybe<TopicEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateArticleArgs = {
  data: ArticleInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateArticleLocalizationArgs = {
  data?: InputMaybe<ArticleInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCommunityDetailArgs = {
  data: CommunityDetailInput;
};


export type MutationCreateContentReleasesReleaseArgs = {
  data: ContentReleasesReleaseInput;
};


export type MutationCreateContentReleasesReleaseActionArgs = {
  data: ContentReleasesReleaseActionInput;
};


export type MutationCreateFreeCourseArgs = {
  data: FreeCourseInput;
};


export type MutationCreateIndustryArgs = {
  data: IndustryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateIndustryLocalizationArgs = {
  data?: InputMaybe<IndustryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateMentorArgs = {
  data: MentorInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateMentorLocalizationArgs = {
  data?: InputMaybe<MentorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePlanDetailArgs = {
  data: PlanDetailInput;
};


export type MutationCreateStandardLpArgs = {
  data: StandardLpInput;
};


export type MutationCreateSubIndustryArgs = {
  data: SubIndustryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSubIndustryLocalizationArgs = {
  data?: InputMaybe<SubIndustryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateTestimonialArgs = {
  data: TestimonialInput;
};


export type MutationCreateTopicArgs = {
  data: TopicInput;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteArticleArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteCommunityDetailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentReleasesReleaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentReleasesReleaseActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFreeCourseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIndustryArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteMentorArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeletePlanDetailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStandardLpArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubIndustryArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteTestimonialArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTopicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateArticleArgs = {
  data: ArticleInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateCommunityDetailArgs = {
  data: CommunityDetailInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateContentReleasesReleaseArgs = {
  data: ContentReleasesReleaseInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateContentReleasesReleaseActionArgs = {
  data: ContentReleasesReleaseActionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateFreeCourseArgs = {
  data: FreeCourseInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateHomeArgs = {
  data: HomeInput;
};


export type MutationUpdateIndustryArgs = {
  data: IndustryInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateMembershipPageArgs = {
  data: MembershipPageInput;
};


export type MutationUpdateMentorArgs = {
  data: MentorInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdatePlanDetailArgs = {
  data: PlanDetailInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateStandardLpArgs = {
  data: StandardLpInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSubIndustryArgs = {
  data: SubIndustryInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateTestimonialArgs = {
  data: TestimonialInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTopicArgs = {
  data: TopicInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanDetail = {
  __typename?: 'PlanDetail';
  PlanBenefits?: Maybe<ComponentMembershipPagePlanBenefits>;
  PlanContent?: Maybe<ComponentMembershipPagePlanContent>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanDetailEntity = {
  __typename?: 'PlanDetailEntity';
  attributes?: Maybe<PlanDetail>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PlanDetailEntityResponse = {
  __typename?: 'PlanDetailEntityResponse';
  data?: Maybe<PlanDetailEntity>;
};

export type PlanDetailEntityResponseCollection = {
  __typename?: 'PlanDetailEntityResponseCollection';
  data: Array<PlanDetailEntity>;
  meta: ResponseCollectionMeta;
};

export type PlanDetailFiltersInput = {
  PlanBenefits?: InputMaybe<ComponentMembershipPagePlanBenefitsFiltersInput>;
  PlanContent?: InputMaybe<ComponentMembershipPagePlanContentFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<PlanDetailFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PlanDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PlanDetailFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PlanDetailInput = {
  PlanBenefits?: InputMaybe<ComponentMembershipPagePlanBenefitsInput>;
  PlanContent?: InputMaybe<ComponentMembershipPagePlanContentInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  article?: Maybe<ArticleEntityResponse>;
  articles?: Maybe<ArticleEntityResponseCollection>;
  communityDetail?: Maybe<CommunityDetailEntityResponse>;
  communityDetails?: Maybe<CommunityDetailEntityResponseCollection>;
  contentReleasesRelease?: Maybe<ContentReleasesReleaseEntityResponse>;
  contentReleasesReleaseAction?: Maybe<ContentReleasesReleaseActionEntityResponse>;
  contentReleasesReleaseActions?: Maybe<ContentReleasesReleaseActionEntityResponseCollection>;
  contentReleasesReleases?: Maybe<ContentReleasesReleaseEntityResponseCollection>;
  freeCourse?: Maybe<FreeCourseEntityResponse>;
  freeCourses?: Maybe<FreeCourseEntityResponseCollection>;
  home?: Maybe<HomeEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  industries?: Maybe<IndustryEntityResponseCollection>;
  industry?: Maybe<IndustryEntityResponse>;
  me?: Maybe<UsersPermissionsMe>;
  membershipPage?: Maybe<MembershipPageEntityResponse>;
  mentor?: Maybe<MentorEntityResponse>;
  mentors?: Maybe<MentorEntityResponseCollection>;
  planDetail?: Maybe<PlanDetailEntityResponse>;
  planDetails?: Maybe<PlanDetailEntityResponseCollection>;
  standardLp?: Maybe<StandardLpEntityResponse>;
  standardLps?: Maybe<StandardLpEntityResponseCollection>;
  subIndustries?: Maybe<SubIndustryEntityResponseCollection>;
  subIndustry?: Maybe<SubIndustryEntityResponse>;
  testimonial?: Maybe<TestimonialEntityResponse>;
  testimonials?: Maybe<TestimonialEntityResponseCollection>;
  topic?: Maybe<TopicEntityResponse>;
  topics?: Maybe<TopicEntityResponseCollection>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryArticleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCommunityDetailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCommunityDetailsArgs = {
  filters?: InputMaybe<CommunityDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryContentReleasesReleaseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContentReleasesReleaseActionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContentReleasesReleaseActionsArgs = {
  filters?: InputMaybe<ContentReleasesReleaseActionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryContentReleasesReleasesArgs = {
  filters?: InputMaybe<ContentReleasesReleaseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFreeCourseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFreeCoursesArgs = {
  filters?: InputMaybe<FreeCourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryHomeArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryIndustriesArgs = {
  filters?: InputMaybe<IndustryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryIndustryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryMembershipPageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryMentorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryMentorsArgs = {
  filters?: InputMaybe<MentorFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPlanDetailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlanDetailsArgs = {
  filters?: InputMaybe<PlanDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryStandardLpArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStandardLpsArgs = {
  filters?: InputMaybe<StandardLpFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySubIndustriesArgs = {
  filters?: InputMaybe<SubIndustryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySubIndustryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryTestimonialArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTestimonialsArgs = {
  filters?: InputMaybe<TestimonialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTopicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTopicsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StandardLp = {
  __typename?: 'StandardLp';
  content?: Maybe<Array<Maybe<StandardLpContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StandardLpContentDynamicZone = ComponentStndardLpCertificate | ComponentStndardLpFaqDetail | ComponentStndardLpKeyOutComes | ComponentStndardLpLearnerDetail | ComponentStndardLpModuleDetail | ComponentStndardLpTargetAudience | ComponentStndardLpWhatYouLearn | Error;

export type StandardLpEntity = {
  __typename?: 'StandardLpEntity';
  attributes?: Maybe<StandardLp>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StandardLpEntityResponse = {
  __typename?: 'StandardLpEntityResponse';
  data?: Maybe<StandardLpEntity>;
};

export type StandardLpEntityResponseCollection = {
  __typename?: 'StandardLpEntityResponseCollection';
  data: Array<StandardLpEntity>;
  meta: ResponseCollectionMeta;
};

export type StandardLpFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StandardLpFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<StandardLpFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StandardLpFiltersInput>>>;
  productId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type StandardLpInput = {
  content?: InputMaybe<Array<Scalars['StandardLpContentDynamicZoneInput']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubIndustry = {
  __typename?: 'SubIndustry';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  freeCourses?: Maybe<FreeCourseRelationResponseCollection>;
  industries?: Maybe<IndustryRelationResponseCollection>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SubIndustryRelationResponseCollection>;
  primaryIndustry?: Maybe<IndustryEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sectionalFaq?: Maybe<Array<Maybe<ComponentComplexComponentsSectionalFaq>>>;
  subIndustry: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SubIndustryFreeCoursesArgs = {
  filters?: InputMaybe<FreeCourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubIndustryIndustriesArgs = {
  filters?: InputMaybe<IndustryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubIndustryLocalizationsArgs = {
  filters?: InputMaybe<SubIndustryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubIndustrySectionalFaqArgs = {
  filters?: InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubIndustryEntity = {
  __typename?: 'SubIndustryEntity';
  attributes?: Maybe<SubIndustry>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubIndustryEntityResponse = {
  __typename?: 'SubIndustryEntityResponse';
  data?: Maybe<SubIndustryEntity>;
};

export type SubIndustryEntityResponseCollection = {
  __typename?: 'SubIndustryEntityResponseCollection';
  data: Array<SubIndustryEntity>;
  meta: ResponseCollectionMeta;
};

export type SubIndustryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubIndustryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  freeCourses?: InputMaybe<FreeCourseFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  industries?: InputMaybe<IndustryFiltersInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SubIndustryFiltersInput>;
  not?: InputMaybe<SubIndustryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubIndustryFiltersInput>>>;
  primaryIndustry?: InputMaybe<IndustryFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sectionalFaq?: InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>;
  subIndustry?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubIndustryInput = {
  freeCourses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  industries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  primaryIndustry?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sectionalFaq?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSectionalFaqInput>>>;
  subIndustry?: InputMaybe<Scalars['String']['input']>;
};

export type SubIndustryRelationResponseCollection = {
  __typename?: 'SubIndustryRelationResponseCollection';
  data: Array<SubIndustryEntity>;
};

export type Testimonial = {
  __typename?: 'Testimonial';
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  prevCompany?: Maybe<Scalars['String']['output']>;
  prevDesignation?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  testimonial?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userImage?: Maybe<UploadFileEntityResponse>;
  userImageUrl?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userProfileType?: Maybe<Enum_Testimonial_Userprofiletype>;
  userProfileUrl?: Maybe<Scalars['String']['output']>;
  videoTestimonial?: Maybe<UploadFileEntityResponse>;
  videoTestimonialUrl?: Maybe<Scalars['String']['output']>;
};

export type TestimonialEntity = {
  __typename?: 'TestimonialEntity';
  attributes?: Maybe<Testimonial>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TestimonialEntityResponse = {
  __typename?: 'TestimonialEntityResponse';
  data?: Maybe<TestimonialEntity>;
};

export type TestimonialEntityResponseCollection = {
  __typename?: 'TestimonialEntityResponseCollection';
  data: Array<TestimonialEntity>;
  meta: ResponseCollectionMeta;
};

export type TestimonialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TestimonialFiltersInput>>>;
  company?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  designation?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<TestimonialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TestimonialFiltersInput>>>;
  prevCompany?: InputMaybe<StringFilterInput>;
  prevDesignation?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  testimonial?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userImageUrl?: InputMaybe<StringFilterInput>;
  userName?: InputMaybe<StringFilterInput>;
  userProfileType?: InputMaybe<StringFilterInput>;
  userProfileUrl?: InputMaybe<StringFilterInput>;
  videoTestimonialUrl?: InputMaybe<StringFilterInput>;
};

export type TestimonialInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  prevCompany?: InputMaybe<Scalars['String']['input']>;
  prevDesignation?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  testimonial?: InputMaybe<Scalars['String']['input']>;
  userImage?: InputMaybe<Scalars['ID']['input']>;
  userImageUrl?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Enum_Testimonial_Userprofiletype>;
  userProfileUrl?: InputMaybe<Scalars['String']['input']>;
  videoTestimonial?: InputMaybe<Scalars['ID']['input']>;
  videoTestimonialUrl?: InputMaybe<Scalars['String']['input']>;
};

export type Topic = {
  __typename?: 'Topic';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<IndustryEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subTopics?: Maybe<Array<Maybe<ComponentComplexComponentsSubTopic>>>;
  topicName: Scalars['String']['output'];
  topicSectionalFaq?: Maybe<Array<Maybe<ComponentComplexComponentsSectionalFaq>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TopicSubTopicsArgs = {
  filters?: InputMaybe<ComponentComplexComponentsSubTopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TopicTopicSectionalFaqArgs = {
  filters?: InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TopicEntity = {
  __typename?: 'TopicEntity';
  attributes?: Maybe<Topic>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TopicEntityResponse = {
  __typename?: 'TopicEntityResponse';
  data?: Maybe<TopicEntity>;
};

export type TopicEntityResponseCollection = {
  __typename?: 'TopicEntityResponseCollection';
  data: Array<TopicEntity>;
  meta: ResponseCollectionMeta;
};

export type TopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TopicFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  industry?: InputMaybe<IndustryFiltersInput>;
  not?: InputMaybe<TopicFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TopicFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subTopics?: InputMaybe<ComponentComplexComponentsSubTopicFiltersInput>;
  topicName?: InputMaybe<StringFilterInput>;
  topicSectionalFaq?: InputMaybe<ComponentComplexComponentsSectionalFaqFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TopicInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subTopics?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSubTopicInput>>>;
  topicName?: InputMaybe<Scalars['String']['input']>;
  topicSectionalFaq?: InputMaybe<Array<InputMaybe<ComponentComplexComponentsSectionalFaqInput>>>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type FooterQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterQuery = { __typename?: 'Query', industries?: { __typename?: 'IndustryEntityResponseCollection', data: Array<{ __typename?: 'IndustryEntity', attributes?: { __typename?: 'Industry', industryName: string, subIndustries?: { __typename?: 'SubIndustryRelationResponseCollection', data: Array<{ __typename?: 'SubIndustryEntity', id?: string | null, attributes?: { __typename?: 'SubIndustry', subIndustry: string } | null }> } | null } | null }> } | null };

export type HomeQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeQuery = { __typename?: 'Query', home?: { __typename?: 'HomeEntityResponse', data?: { __typename?: 'HomeEntity', attributes?: { __typename?: 'Home', content?: Array<{ __typename: 'ComponentHomeAdvantage', SmallText?: string | null, BigText?: string | null, Slider?: Array<{ __typename?: 'ComponentComplexComponentsImageCard', SmallText?: string | null, BigText?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeBehindOurGrowth', SmallText?: string | null, BigText?: string | null, SubTitle?: string | null, CompanyLogos?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null }> } | null, GrowthTeamImages?: Array<{ __typename?: 'ComponentSimpleComponentsGrowthTeamImages', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeFeedBackDetail', SmallText?: string | null, BigText?: string | null, FeedBackCards?: Array<{ __typename?: 'ComponentHomeFeedBackCards', Description?: string | null, Name?: string | null, Designation?: string | null, SocialLink?: string | null, IsTextTestimonial?: boolean | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, SocialIcon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, Video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeFirstBlock', Title?: string | null, Description?: string | null, CTA?: { __typename?: 'ComponentSimpleComponentsButton', Text?: string | null, Link?: string | null } | null, TextScroll?: Array<{ __typename?: 'ComponentSimpleComponentsTextScroll', Text?: string | null } | null> | null } | { __typename: 'ComponentHomeGlimpse', Title?: string | null, QuizLink?: { __typename?: 'ComponentSimpleComponentsButton', Text?: string | null, Link?: string | null } | null } | { __typename: 'ComponentHomeOurCommunity', Caption?: string | null, Title?: string | null, Description?: string | null, ButtonText?: string | null, ButtonLink?: string | null, Categories?: Array<{ __typename?: 'ComponentSimpleComponentsCategories', id: string, CategoryName?: string | null, BigText?: string | null, SmallText?: string | null, community_details?: { __typename?: 'CommunityDetailRelationResponseCollection', data: Array<{ __typename?: 'CommunityDetailEntity', attributes?: { __typename?: 'CommunityDetail', CommunityDetail?: { __typename?: 'ComponentHomeCommunityImages', Caption?: string | null, Location?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null } | null }> } | null } | null> | null } | { __typename: 'ComponentHomeRecommendedCard', SmallText?: string | null, BigText?: string | null, Crads?: Array<{ __typename?: 'ComponentHomeCrads', id: string, Description?: string | null, Name?: string | null, Designation?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeSecondBlock', StudentCount?: any | null, StudentText?: string | null, StudentDescription?: string | null, Students?: Array<{ __typename?: 'ComponentComplexComponentsImages', StudentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, CompanyImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null, TrustCards?: Array<{ __typename?: 'ComponentComplexComponentsImageCard', SmallText?: string | null, BigText?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeSkillUpDetail', Caption?: string | null, Title?: string | null, SubTitle?: string | null, ButtonText?: string | null, ButtonLink?: string | null, WhyUsTitle?: string | null, BrandCollabTitle?: string | null, WhyUs?: Array<{ __typename?: 'ComponentHomeWhyUs', Title?: string | null, Description?: string | null, Icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null, CollaborationBrand?: Array<{ __typename?: 'ComponentSimpleComponentsBrandLogos', Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeSuccessStories', SmallText?: string | null, BigText?: string | null, SuccessCard?: Array<{ __typename?: 'ComponentComplexComponentsSuccessCard', StudentName?: string | null, FromText?: string | null, FromCompany?: string | null, ToText?: string | null, ToCompany?: string | null, StudentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeTopBrands', Title?: string | null, BrandLogos?: Array<{ __typename?: 'ComponentSimpleComponentsBrandLogos', Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'Error' } | null> | null } | null } | null } | null, testimonials?: { __typename?: 'TestimonialEntityResponseCollection', data: Array<{ __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', userName?: string | null, designation?: string | null, prevDesignation?: string | null, company?: string | null, testimonial?: string | null, userImageUrl?: string | null, prevCompany?: string | null, userImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null }> } | null };

export type HomeSlpQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeSlpQuery = { __typename?: 'Query', home?: { __typename?: 'HomeEntityResponse', data?: { __typename?: 'HomeEntity', attributes?: { __typename?: 'Home', content?: Array<{ __typename: 'ComponentHomeAdvantage' } | { __typename: 'ComponentHomeBehindOurGrowth' } | { __typename: 'ComponentHomeFeedBackDetail', SmallText?: string | null, BigText?: string | null, FeedBackCards?: Array<{ __typename?: 'ComponentHomeFeedBackCards', Description?: string | null, Name?: string | null, Designation?: string | null, SocialLink?: string | null, IsTextTestimonial?: boolean | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, SocialIcon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, Video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeFirstBlock' } | { __typename: 'ComponentHomeGlimpse' } | { __typename: 'ComponentHomeOurCommunity' } | { __typename: 'ComponentHomeRecommendedCard' } | { __typename: 'ComponentHomeSecondBlock' } | { __typename: 'ComponentHomeSkillUpDetail', Caption?: string | null, Title?: string | null, SubTitle?: string | null, ButtonText?: string | null, ButtonLink?: string | null, WhyUsTitle?: string | null, BrandCollabTitle?: string | null, WhyUs?: Array<{ __typename?: 'ComponentHomeWhyUs', Title?: string | null, Description?: string | null, Icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null, CollaborationBrand?: Array<{ __typename?: 'ComponentSimpleComponentsBrandLogos', Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentHomeSuccessStories' } | { __typename: 'ComponentHomeTopBrands' } | { __typename: 'Error' } | null> | null } | null } | null } | null };

export type MemberShipPageQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberShipPageQuery = { __typename?: 'Query', membershipPage?: { __typename?: 'MembershipPageEntityResponse', data?: { __typename?: 'MembershipPageEntity', attributes?: { __typename?: 'MembershipPage', HeroSection?: { __typename?: 'ComponentMembershipPageHeroSection', Title?: string | null, Description?: string | null, ButtonText?: string | null, ButtonLink?: string | null, SmallText?: string | null, Price?: string | null, Hide?: boolean | null, Thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, Video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null, CoursesDetail?: { __typename?: 'ComponentMembershipPageCoursesDetail', CaptionText?: string | null, Title?: string | null, Description?: string | null, Hide?: boolean | null, CoursesCards?: Array<{ __typename?: 'ComponentMembershipPageCoursesCards', Title?: string | null, WorthText?: string | null, Price?: string | null, Details?: Array<{ __typename?: 'ComponentMembershipPageDetails', Detail?: string | null } | null> | null } | null> | null } | null, CommunitySpace?: { __typename?: 'ComponentMembershipPageCommunitySpace', CaptionText?: string | null, Title?: string | null, Description?: string | null, Hide?: boolean | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null, DoubtSection?: { __typename?: 'ComponentMembershipPageDoubtSection', CaptionText?: string | null, Title?: string | null, Description?: string | null, Hide?: boolean | null, DoubtTopics?: Array<{ __typename?: 'ComponentMembershipPageDoubtTopics', Title?: string | null, Description?: string | null, Icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | null, OurCommunity?: { __typename?: 'ComponentHomeOurCommunity', Caption?: string | null, Title?: string | null, Description?: string | null, ButtonText?: string | null, ButtonLink?: string | null, Categories?: Array<{ __typename?: 'ComponentSimpleComponentsCategories', id: string, CategoryName?: string | null, BigText?: string | null, SmallText?: string | null, community_details?: { __typename?: 'CommunityDetailRelationResponseCollection', data: Array<{ __typename?: 'CommunityDetailEntity', attributes?: { __typename?: 'CommunityDetail', CommunityDetail?: { __typename?: 'ComponentHomeCommunityImages', Caption?: string | null, Location?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null } | null }> } | null } | null> | null } | null, JobBoard?: { __typename?: 'ComponentMembershipPageJobBoard', CaptionText?: string | null, Title?: string | null, Description?: string | null, ComingSoon?: string | null, Hide?: boolean | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null, PlanDetail?: { __typename?: 'ComponentMembershipPagePlanDetail', Title?: string | null, SubTitle?: string | null, PlanCategory?: Array<{ __typename?: 'ComponentMembershipPagePlanCategory', PlanName?: string | null, plan_detail?: { __typename?: 'PlanDetailEntityResponse', data?: { __typename?: 'PlanDetailEntity', attributes?: { __typename?: 'PlanDetail', PlanContent?: { __typename?: 'ComponentMembershipPagePlanContent', ProMembership?: string | null, AllAccess?: string | null, SelfPlacedCourse?: string | null, ProCourses?: string | null, AllAccessCourses?: string | null, Hide?: boolean | null, ProPlanPrice?: string | null, ContentDetail?: Array<{ __typename?: 'ComponentMembershipPageContentDetail', Name?: string | null, IsGsPro?: boolean | null, IsAllAccess?: boolean | null } | null> | null } | null, PlanBenefits?: { __typename?: 'ComponentMembershipPagePlanBenefits', Title?: string | null, SubTitle?: string | null, TotalText?: string | null, TotalPrice?: string | null, OfferText?: string | null, OfferPrice?: string | null, Hide?: boolean | null, BenefitsDetail?: Array<{ __typename?: 'ComponentMembershipPageBenefitsDetail', Detail?: string | null, Price?: string | null } | null> | null } | null } | null } | null } | null } | null> | null } | null, FaqDetail?: { __typename?: 'ComponentComplexComponentsSectionalFaq', title?: string | null, CaptionText?: string | null, Hide?: boolean | null, faq?: Array<{ __typename?: 'ComponentSimpleComponentsFaq', question?: string | null, answer?: string | null } | null> | null } | null } | null } | null } | null };
export type InMemberShipPageQuery = { __typename?: 'Query', inMembershipPage?: { __typename?: 'MembershipPageEntityResponse', data?: { __typename?: 'MembershipPageEntity', attributes?: { __typename?: 'InMembershipPage', HeroSection?: { __typename?: 'ComponentMembershipPageHeroSection', Title?: string | null, Description?: string | null, ButtonText?: string | null, ButtonLink?: string | null, SmallText?: string | null, Price?: string | null, Hide?: boolean | null, Thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, Video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null, CoursesDetail?: { __typename?: 'ComponentMembershipPageCoursesDetail', CaptionText?: string | null, Title?: string | null, Description?: string | null, Hide?: boolean | null, CoursesCards?: Array<{ __typename?: 'ComponentMembershipPageCoursesCards', Title?: string | null, WorthText?: string | null, Price?: string | null, Details?: Array<{ __typename?: 'ComponentMembershipPageDetails', Detail?: string | null } | null> | null } | null> | null } | null, CommunitySpace?: { __typename?: 'ComponentMembershipPageCommunitySpace', CaptionText?: string | null, Title?: string | null, Description?: string | null, Hide?: boolean | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null, DoubtSection?: { __typename?: 'ComponentMembershipPageDoubtSection', CaptionText?: string | null, Title?: string | null, Description?: string | null, Hide?: boolean | null, DoubtTopics?: Array<{ __typename?: 'ComponentMembershipPageDoubtTopics', Title?: string | null, Description?: string | null, Icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | null, OurCommunity?: { __typename?: 'ComponentHomeOurCommunity', Caption?: string | null, Title?: string | null, Description?: string | null, ButtonText?: string | null, ButtonLink?: string | null, Categories?: Array<{ __typename?: 'ComponentSimpleComponentsCategories', id: string, CategoryName?: string | null, BigText?: string | null, SmallText?: string | null, community_details?: { __typename?: 'CommunityDetailRelationResponseCollection', data: Array<{ __typename?: 'CommunityDetailEntity', attributes?: { __typename?: 'CommunityDetail', CommunityDetail?: { __typename?: 'ComponentHomeCommunityImages', Caption?: string | null, Location?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null } | null }> } | null } | null> | null } | null, JobBoard?: { __typename?: 'ComponentMembershipPageJobBoard', CaptionText?: string | null, Title?: string | null, Description?: string | null, ComingSoon?: string | null, Hide?: boolean | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null, PlanDetail?: { __typename?: 'ComponentMembershipPagePlanDetail', Title?: string | null, SubTitle?: string | null, PlanCategory?: Array<{ __typename?: 'ComponentMembershipPagePlanCategory', PlanName?: string | null, plan_detail?: { __typename?: 'PlanDetailEntityResponse', data?: { __typename?: 'PlanDetailEntity', attributes?: { __typename?: 'PlanDetail', PlanContent?: { __typename?: 'ComponentMembershipPagePlanContent', ProMembership?: string | null, AllAccess?: string | null, SelfPlacedCourse?: string | null, ProCourses?: string | null, AllAccessCourses?: string | null, Hide?: boolean | null, ProPlanPrice?: string | null, ContentDetail?: Array<{ __typename?: 'ComponentMembershipPageContentDetail', Name?: string | null, IsGsPro?: boolean | null, IsAllAccess?: boolean | null } | null> | null } | null, PlanBenefits?: { __typename?: 'ComponentMembershipPagePlanBenefits', Title?: string | null, SubTitle?: string | null, TotalText?: string | null, TotalPrice?: string | null, OfferText?: string | null, OfferPrice?: string | null, Hide?: boolean | null, BenefitsDetail?: Array<{ __typename?: 'ComponentMembershipPageBenefitsDetail', Detail?: string | null, Price?: string | null } | null> | null } | null } | null } | null } | null } | null> | null } | null, FaqDetail?: { __typename?: 'ComponentComplexComponentsSectionalFaq', title?: string | null, CaptionText?: string | null, Hide?: boolean | null, faq?: Array<{ __typename?: 'ComponentSimpleComponentsFaq', question?: string | null, answer?: string | null } | null> | null } | null } | null } | null } | null };

export type StandardLpQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StandardLpQuery = { __typename?: 'Query', standardLps?: { __typename?: 'StandardLpEntityResponseCollection', data: Array<{ __typename?: 'StandardLpEntity', attributes?: { __typename?: 'StandardLp', slug?: string | null, productId?: string | null, content?: Array<{ __typename: 'ComponentStndardLpCertificate', SectionInfo?: { __typename?: 'ComponentStndardLpModuleDetail', SmallText?: string | null, BigText?: string | null, Description?: string | null } | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | { __typename: 'ComponentStndardLpFaqDetail', SmallText?: string | null, BigText?: string | null, FaqDetail?: Array<{ __typename?: 'ComponentSimpleComponentsFaq', question?: string | null, answer?: string | null } | null> | null } | { __typename: 'ComponentStndardLpKeyOutComes', SmallText?: string | null, BigText?: string | null, Description?: string | null } | { __typename: 'ComponentStndardLpLearnerDetail', StudentCount?: any | null, StudentText?: string | null, SmallText?: string | null, BigText?: string | null, StudentDescription?: string | null, Students?: Array<{ __typename?: 'ComponentComplexComponentsImages', StudentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, CompanyImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null, LearnerInfo?: Array<{ __typename?: 'ComponentSimpleComponentsLearnerInfo', Description?: string | null, Icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null, SocialIcon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, CompanyLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | { __typename: 'ComponentStndardLpModuleDetail', SmallText?: string | null, BigText?: string | null, Description?: string | null } | { __typename: 'ComponentStndardLpTargetAudience', SmallText?: string | null, BigText?: string | null, Description?: string | null, AudienceDetail?: Array<{ __typename?: 'ComponentSimpleComponentsAudienceDetail', Title?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | { __typename: 'ComponentStndardLpWhatYouLearn', SmallText?: string | null, BigText?: string | null, ModuleDetail?: Array<{ __typename?: 'ComponentStndardLpModuleDetail', SmallText?: string | null, BigText?: string | null, Description?: string | null } | null> | null } | { __typename: 'Error' } | null> | null } | null }> } | null };


export const FooterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Footer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"industries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"999999"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"industryName"}},{"kind":"Field","name":{"kind":"Name","value":"subIndustries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"99999"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subIndustry"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FooterQuery, FooterQueryVariables>;
export const HomeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeFirstBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CTA"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Text"}},{"kind":"Field","name":{"kind":"Name","value":"Link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TextScroll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"9999"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeSecondBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StudentCount"}},{"kind":"Field","name":{"kind":"Name","value":"StudentText"}},{"kind":"Field","name":{"kind":"Name","value":"StudentDescription"}},{"kind":"Field","name":{"kind":"Name","value":"Students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StudentImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CompanyImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"TrustCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeGlimpse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"QuizLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Text"}},{"kind":"Field","name":{"kind":"Name","value":"Link"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeAdvantage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Slider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeSuccessStories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"SuccessCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StudentImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"StudentName"}},{"kind":"Field","name":{"kind":"Name","value":"FromText"}},{"kind":"Field","name":{"kind":"Name","value":"FromCompany"}},{"kind":"Field","name":{"kind":"Name","value":"ToText"}},{"kind":"Field","name":{"kind":"Name","value":"ToCompany"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeTopBrands"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"BrandLogos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"999"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeFeedBackDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"FeedBackCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"999"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Designation"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"SocialIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"SocialLink"}},{"kind":"Field","name":{"kind":"Name","value":"Video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsTextTestimonial"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeSkillUpDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Caption"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonLink"}},{"kind":"Field","name":{"kind":"Name","value":"WhyUsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"WhyUs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"BrandCollabTitle"}},{"kind":"Field","name":{"kind":"Name","value":"CollaborationBrand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeOurCommunity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Caption"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonLink"}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"CategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"community_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CommunityDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Caption"}},{"kind":"Field","name":{"kind":"Name","value":"Location"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"SmallText"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeRecommendedCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Crads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Designation"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeBehindOurGrowth"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyLogos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"GrowthTeamImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"999"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"999"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"designation"}},{"kind":"Field","name":{"kind":"Name","value":"prevDesignation"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"testimonial"}},{"kind":"Field","name":{"kind":"Name","value":"userImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"prevCompany"}},{"kind":"Field","name":{"kind":"Name","value":"userImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<HomeQuery, HomeQueryVariables>;
export const HomeSlpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeSLP"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeFeedBackDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"FeedBackCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"999"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Designation"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"SocialIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"SocialLink"}},{"kind":"Field","name":{"kind":"Name","value":"Video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsTextTestimonial"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentHomeSkillUpDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Caption"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonLink"}},{"kind":"Field","name":{"kind":"Name","value":"WhyUsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"WhyUs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"BrandCollabTitle"}},{"kind":"Field","name":{"kind":"Name","value":"CollaborationBrand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<HomeSlpQuery, HomeSlpQueryVariables>;
export const MemberShipPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberShipPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HeroSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonLink"}},{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"Price"}},{"kind":"Field","name":{"kind":"Name","value":"Thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CoursesDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"CoursesCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"WorthText"}},{"kind":"Field","name":{"kind":"Name","value":"Price"}},{"kind":"Field","name":{"kind":"Name","value":"Details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Detail"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CommunitySpace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"DoubtSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DoubtTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}}]}},{"kind":"Field","name":{"kind":"Name","value":"OurCommunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Caption"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonLink"}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"CategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"community_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CommunityDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Caption"}},{"kind":"Field","name":{"kind":"Name","value":"Location"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"SmallText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"JobBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ComingSoon"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"PlanDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"PlanCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PlanName"}},{"kind":"Field","name":{"kind":"Name","value":"plan_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PlanContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ProMembership"}},{"kind":"Field","name":{"kind":"Name","value":"AllAccess"}},{"kind":"Field","name":{"kind":"Name","value":"SelfPlacedCourse"}},{"kind":"Field","name":{"kind":"Name","value":"ProCourses"}},{"kind":"Field","name":{"kind":"Name","value":"AllAccessCourses"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"ProPlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"AllAccessPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ContentDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"IsGsPro"}},{"kind":"Field","name":{"kind":"Name","value":"IsAllAccess"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"PlanBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"TotalText"}},{"kind":"Field","name":{"kind":"Name","value":"TotalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"OfferText"}},{"kind":"Field","name":{"kind":"Name","value":"OfferPrice"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"BenefitsDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Detail"}},{"kind":"Field","name":{"kind":"Name","value":"Price"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"FaqDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"faq"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MemberShipPageQuery, MemberShipPageQueryVariables>;
export const InMemberShipPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InMemberShipPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inMembershipPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"HeroSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonLink"}},{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"Price"}},{"kind":"Field","name":{"kind":"Name","value":"Thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CoursesDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"CoursesCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"WorthText"}},{"kind":"Field","name":{"kind":"Name","value":"Price"}},{"kind":"Field","name":{"kind":"Name","value":"Details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Detail"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CommunitySpace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"DoubtSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DoubtTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}}]}},{"kind":"Field","name":{"kind":"Name","value":"OurCommunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Caption"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"ButtonLink"}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"CategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"community_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CommunityDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Caption"}},{"kind":"Field","name":{"kind":"Name","value":"Location"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"SmallText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"JobBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ComingSoon"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"PlanDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"PlanCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PlanName"}},{"kind":"Field","name":{"kind":"Name","value":"plan_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PlanContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ProMembership"}},{"kind":"Field","name":{"kind":"Name","value":"AllAccess"}},{"kind":"Field","name":{"kind":"Name","value":"SelfPlacedCourse"}},{"kind":"Field","name":{"kind":"Name","value":"ProCourses"}},{"kind":"Field","name":{"kind":"Name","value":"AllAccessCourses"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"ProPlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"AllAccessPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ContentDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"IsGsPro"}},{"kind":"Field","name":{"kind":"Name","value":"IsAllAccess"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"PlanBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"TotalText"}},{"kind":"Field","name":{"kind":"Name","value":"TotalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"OfferText"}},{"kind":"Field","name":{"kind":"Name","value":"OfferPrice"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"BenefitsDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Detail"}},{"kind":"Field","name":{"kind":"Name","value":"Price"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"FaqDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"CaptionText"}},{"kind":"Field","name":{"kind":"Name","value":"Hide"}},{"kind":"Field","name":{"kind":"Name","value":"faq"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InMemberShipPageQuery, MemberShipPageQueryVariables>;
export const StandardLpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StandardLP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standardLps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentStndardLpKeyOutComes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentStndardLpLearnerDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StudentCount"}},{"kind":"Field","name":{"kind":"Name","value":"StudentText"}},{"kind":"Field","name":{"kind":"Name","value":"Students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"StudentImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CompanyImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"LearnerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"SocialIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"StudentDescription"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentStndardLpWhatYouLearn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"ModuleDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"25"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentStndardLpTargetAudience"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"AudienceDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"25"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentStndardLpModuleDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentStndardLpCertificate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SectionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentStndardLpFaqDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmallText"}},{"kind":"Field","name":{"kind":"Name","value":"BigText"}},{"kind":"Field","name":{"kind":"Name","value":"FaqDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StandardLpQuery, StandardLpQueryVariables>;